import withContext from "./src/app/WrapRootElement";
import WithAnimationAndCookies from "./src/app/WrapPageElement";
import "./src/styles/main.scss"

export const wrapRootElement = withContext
export const wrapPageElement = WithAnimationAndCookies

